export const GET_PROFILE = 'GET_PROFILE'
export const SET_PROFILE = 'SET_PROFILE'
export const CLEAR_PROFILE = 'CLEAR_PROFILE'
export const SET_CURRENT = 'SET_CURRENT'
export const CHANGE_PROFILE = 'CHANGE_PROFILE'
